import { NotificationListResponse, UserNotification } from '../../models/notification.model';

export class LoadNotifications {
  static readonly type = '[Notification] Load';
  constructor(public payload: { page: number; pageSize: number }) {}
}

export class LoadNotificationsSuccess {
  static readonly type = '[Notification] Load Success';
  constructor(public response: NotificationListResponse) {}
}

export class LoadNotificationsFail {
  static readonly type = '[Notification] Load Fail';
  constructor(public error: any) {}
}

export class LoadUnreadCount {
  static readonly type = '[Notification] Load Unread Count';
}

export class LoadUnreadCountSuccess {
  static readonly type = '[Notification] Load Unread Count Success';
  constructor(public count: number) {}
}

export class MarkNotificationAsRead {
  static readonly type = '[Notification] Mark As Read';
  constructor(public notificationId: number) {}
}

export class MarkNotificationAsReadSuccess {
  static readonly type = '[Notification] Mark As Read Success';
  constructor(public notificationId: number) {}
}

export class MarkAllNotificationsAsRead {
  static readonly type = '[Notification] Mark All As Read';
}

export class ReceiveRealtimeNotification {
  static readonly type = '[Notification] Receive Realtime';
  constructor(public notification: UserNotification) {}
}
